import { render, staticRenderFns } from "./ManualBookingDaily.vue?vue&type=template&id=196d4d06&"
import script from "./ManualBookingDaily.vue?vue&type=script&lang=ts&"
export * from "./ManualBookingDaily.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports